import { AspectRatio, Box, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import PampaImage from "@raiden/library/components/PampaImage";
import useTranslate from "@raiden/library/hooks/useTranslate";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";
import { getPostPath } from "../../helpers/posts/getPostPath";
import { CenteredContent } from "../CenteredContent";
import { DataHandler } from "../DataHandler";
import { Href } from "../Href";
/**
 * @typedef {object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post[]>>} swrResponsePageList
 */
/**
 * @param {Props} props
 */
export function AccompaniementAndAdvises({ swrResponsePageList }) {
  const translate = useTranslate();

  return (
    <DataHandler
      swrResponse={swrResponsePageList}
      keepDataOnRevalidation={true}
      renderNoResultSplash={false}
      wrapper={(children) => <Box px="1.25rem">{children}</Box>}>
      {({ data: postList }) => {
        return (
          <Box padding="3rem .625rem">
            <CenteredContent>
              <Stack spacing="1.5rem">
                <Stack spacing=".5rem">
                  <Text variant="h1">
                    <FormattedMessage defaultMessage="Accompagnement" />
                  </Text>

                  <Text variant="h2">
                    <FormattedMessage defaultMessage="Nos conseils d’experts selon vos besoins" />
                  </Text>
                </Stack>

                <SimpleGrid columns={{ base: 1, md: 2 }} spacing="1.5rem">
                  {postList.map((post) => (
                    <Href
                      href={getPostPath({
                        postId: post.id,
                        postType: post.type,
                        postSlug: post.current_revision?.slug ?? null,
                        translate,
                      })}
                      key={post.id}>
                      <Box position="relative">
                        <Box position="relative">
                          <AspectRatio ratio={{ base: 33 / 30, md: 437 / 245 }}>
                            <PampaImage
                              image={post.current_revision?.cover}
                              format="small"
                              mode="crop"
                              placeholderSrc={generateFrontPath({
                                id: "@front.internal-assets",
                                parameters: { filePath: "placeholder.png" },
                                includeBasePath: true,
                              })}
                              objectFit="cover"
                              _hover={{
                                transform: "scale(1.1)",
                              }}
                              transition="all 0.25s ease"
                              alt=""
                              minHeight={{ base: "330px", md: "245px" }}
                            />
                          </AspectRatio>

                          <Box
                            position="absolute"
                            top="0"
                            left="0"
                            width="100%"
                            height="100%"
                            background="rgba(47, 47, 89)"
                            opacity="0.2"
                            mixBlendMode="darken"
                            zIndex="1"
                            pointerEvents="none"
                          />
                        </Box>

                        <Stack
                          spacing="1rem"
                          position="absolute"
                          zIndex={4}
                          top="50%"
                          transform="translate(-50%, -50%)"
                          pointerEvents="none"
                          left="50%"
                          width="full"
                          textAlign="center"
                          px="1rem">
                          <Text
                            variant="h2"
                            mb=".5rem"
                            noOfLines={2}
                            color="white">
                            {translate(post.current_revision?.title)}
                          </Text>

                          <Text noOfLines={4} color="white">
                            {translate(post.current_revision?.summary)}
                          </Text>
                        </Stack>
                      </Box>
                    </Href>
                  ))}
                </SimpleGrid>
              </Stack>
            </CenteredContent>
          </Box>
        );
      }}
    </DataHandler>
  );
}
